import { Box, InputBase, useTheme } from "@mui/material";

import { useTranslation } from "react-i18next";
import { tokens } from "../../../theme";
import SHModal from "../Modal/SHModal";
import Subheading from "../text/Subheading";

const MSearch = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }


    return(
        <SHModal
            className={`search-modal${props.modalClassName ? ` ${props.modalClassName}` : ""}`}
            open={props.open}
            onClose={props.handleClose}
            modalSx={props.modalSx}
            sx={props.sx}
        >
            <Box
                sx={{
                    paddingTop:3,
                    paddingBottom:2.5,
                    paddingX:3,
                    display:"flex",
                    alignItems:'center',
                    flexDirection:"column",
                    gap:1.5,
                    // borderBottomRightRadius:0,
                }}
            >
                {props.title && (
                    <Subheading semibold>{props.title}</Subheading>
                )}

                <Box
                    sx={{
                        width:1,
                        position:'relative',
                        display:"flex",
                        borderRadius:4,
                        background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[200],
                    }}
                >
                    <InputBase
                        ref={props.inputRef}
                        sx={{
                            px:1.5,
                            lineHeight:"32px",
                            minWidth:300,
                            height:32,
                            fontSize:14,
                            flex:1,
                            color: colors.txt["primary"],
                        }}
                        placeholder={t("search")}
                        value={props.value}
                        onChange={props.handleSearchChange}
                    />
                </Box>
            </Box>

            {/* BODY */}
            <Box
                sx={{
                    minHeight:300,
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    // borderTopLeftRadius:16,
                    // borderTopRightRadius:16,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    pb:1.5,
                    display:"flex",
                    flexDirection:"column",
                    gap:2,
                    maxHeight:400,
                    overflow:"hidden",
                }}
            >
                {props.searchContainer}
            </Box>
            {/* <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={props.handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton isLoading={isLoading} className={"group-btn"} color={"green"}
                    variant="contained" 
                    onClick={() => SaveRelationContact(relationContactInfo, props)}
                    >{t("add")}</Shbutton>
                </ButtonGroup>
            </Box> */}
        </SHModal>
    )
}

export default MSearch;
